import styled from 'styled-components';

export const ScPreloaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
`;

export const ScPreloaderMain = styled.main`
  position: fixed;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background-color: ${({ theme }) => theme.blackColor};
`;
